import { TConnectedPrinter as TCP } from './hooks/useSpeedloPrinter'

export * from './components/PrintWatch'
export * from './components/PrintWatchIndicator'
export * from './models/usePrintWatchModel'
export * from './types/printWatch.types'

export type TConnectedPrinter = TCP
